// extracted by mini-css-extract-plugin
module.exports = {"aggregatorPin":"AggregatorPin-module--aggregator-pin--2UP8D","aggregatorPinText":"AggregatorPin-module--aggregator-pin-text--2qDOJ"};